import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempootravelleronrent() {

const cardData = {
keyword: "Tempo Traveller On Rent in Pimpri Chinchwad",
headingDescription: "Ruturaj Enterprises provides comfortable and practical Tempo Traveller rental services in Pimpri Chinchwad for families, friends, corporate teams, school groups, wedding guests, tourists, and organized travel parties. A Tempo Traveller is a convenient choice when several passengers want to travel together with comfortable seating, useful luggage space, and a flexible itinerary instead of arranging multiple cars. From weekend getaways and one-day excursions to airport transfers, corporate events, family holidays, pilgrimages, and extended tours across Maharashtra and nearby states, travel arrangements can be planned according to the group size, destination, schedule, and overall journey requirements.",
topPlaces: [
{
title: "Bhimashankar",
description: "Bhimashankar is a popular nature and pilgrimage destination from Pimpri Chinchwad, making it suitable for family groups and organized weekend journeys. A Tempo Traveller allows passengers to travel together with space for luggage and personal belongings while conveniently visiting the temple, forest surroundings, viewpoints, and nearby attractions."
},
{
title: "Goa",
description: "For a longer Pimpri Chinchwad to Goa road trip, a Tempo Traveller provides a practical shared transportation option for families, friends, corporate teams, and tour groups. The spacious cabin is useful for extended highway travel, while sufficient luggage space supports multi-day beach holidays and itineraries involving several destinations."
},
{
title: "Shirdi",
description: "Groups planning a pilgrimage from Pimpri Chinchwad to Shirdi can use a Tempo Traveller for comfortable and coordinated road transportation. It is particularly convenient for families and religious groups who want to remain together during the journey and may also include nearby temples or destinations within their travel schedule."
},
{
title: "Dapoli",
description: "Dapoli offers a peaceful coastal getaway for groups traveling from Pimpri Chinchwad, and a Tempo Traveller makes shared travel easier for medium-sized parties. The vehicle provides useful room for passengers and luggage, making it suitable for family vacations, college trips, weekend outings, and group beach holidays."
},
{
title: "Nashik",
description: "Pimpri Chinchwad to Nashik travel can be arranged in a Tempo Traveller for family tours, corporate visits, religious journeys, and sightseeing programs. Traveling together in one vehicle helps simplify group coordination while leaving practical space for luggage and additional stops around temples, nature attractions, and other destinations."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a scenic hill destination that works well for group road trips from Pimpri Chinchwad, with a Tempo Traveller providing comfortable shared transportation. Families, friends, and corporate groups can carry their belongings conveniently while planning visits to viewpoints, markets, resorts, strawberry farms, and nearby Panchgani."
},
{
title: "Ganpatipule",
description: "A Tempo Traveller is a convenient choice for groups traveling from Pimpri Chinchwad to Ganpatipule for a coastal holiday or religious trip. Its spacious passenger arrangement is useful for longer journeys where travelers need room for bags, personal items, and other essentials during a multi-day itinerary."
},
{
title: "Kolhapur",
description: "Pimpri Chinchwad to Kolhapur journeys can be planned in a Tempo Traveller for family visits, temple tours, corporate travel, and group sightseeing. Shared transportation keeps passengers together throughout the road journey and provides a practical setup for carrying luggage and visiting multiple locations around the destination."
},
{
title: "Bhandardara",
description: "Bhandardara is suitable for nature-focused group trips from Pimpri Chinchwad, and a Tempo Traveller provides convenient transportation for families, friends, and organized groups. The vehicle can accommodate passengers and travel bags while supporting itineraries involving lakes, scenic viewpoints, trekking areas, and nearby attractions."
},
{
title: "Panchgani",
description: "Panchgani provides a refreshing hill-station option for groups traveling from Pimpri Chinchwad, and a Tempo Traveller makes it easier for everyone to travel together. It can support family outings, school excursions, corporate trips, and one-day tours involving multiple viewpoints, attractions, restaurants, and nearby sightseeing locations."
}
],
services: [
{
name: "Tempo Traveller Rental Pimpri Chinchwad",
description: "Tempo Traveller rental in Pimpri Chinchwad provides a convenient transportation solution for families, friends, corporate teams, school groups, and tourists who want to travel together. Ruturaj Enterprises can arrange the vehicle for local journeys, sightseeing, airport transfers, events, weekend trips, and longer routes according to the required travel date, destination, duration, and group requirements."
},
{
name: "Tempo Traveller Hire Pimpri Chinchwad",
description: "Tempo Traveller hire in Pimpri Chinchwad is suitable for groups seeking comfortable shared transportation with practical passenger and luggage space. The service can support family holidays, corporate movement, weddings, school tours, tourist journeys, religious trips, and outstation travel where keeping everyone together is an important part of the itinerary."
},
{
name: "Tempo Traveller Booking Pimpri Chinchwad",
description: "Tempo Traveller booking in Pimpri Chinchwad allows travelers to organize group transportation in advance around their preferred travel date, pickup location, destination, and trip duration. Early planning is especially useful for weddings, school excursions, corporate events, airport schedules, holiday seasons, and multi-day tours requiring coordinated transportation."
},
{
name: "AC Tempo Traveller Pimpri Chinchwad",
description: "An AC Tempo Traveller in Pimpri Chinchwad provides a comfortable air-conditioned environment for group journeys, particularly during warm weather and extended highway travel. It is suitable for families, tourists, corporate teams, school groups, and event participants who want to remain together in a comfortable cabin throughout the journey."
},
{
name: "Luxury Tempo Traveller Pimpri Chinchwad",
description: "Luxury Tempo Traveller services in Pimpri Chinchwad are suitable for travelers who prefer a more premium group transportation experience for special journeys and important occasions. The vehicle can be considered for corporate movement, wedding travel, family vacations, executive groups, airport transfers, and tourist tours where enhanced comfort and presentation are valued."
},
{
name: "Tempo Traveller for Outstation Pimpri Chinchwad",
description: "Tempo Traveller for outstation travel from Pimpri Chinchwad is a practical option for medium-sized groups heading toward destinations across Maharashtra and nearby states. Comfortable shared seating and useful luggage capacity make it suitable for long highway journeys, family vacations, pilgrimages, weekend getaways, and multi-day sightseeing programs."
},
{
name: "Tempo Traveller for Family Trip Pimpri Chinchwad",
description: "Families planning a trip from Pimpri Chinchwad can choose a Tempo Traveller when relatives and family members want to travel together in one vehicle. It works well for hill stations, beaches, religious destinations, nature tours, weekend vacations, and multi-day holidays where passengers may carry additional luggage and personal belongings."
},
{
name: "Tempo Traveller for Group Travel Pimpri Chinchwad",
description: "Tempo Traveller for group travel in Pimpri Chinchwad offers a convenient alternative to arranging several separate cars for friends, relatives, colleagues, or organized travel parties. A shared vehicle keeps the group together while simplifying pickup coordination, route planning, luggage handling, sightseeing stops, and return travel arrangements."
},
{
name: "Tempo Traveller for Corporate Events Pimpri Chinchwad",
description: "Corporate events can use Tempo Traveller transportation in Pimpri Chinchwad for conferences, meetings, seminars, exhibitions, employee outings, team activities, and company programs. Group transportation can be coordinated between offices, hotels, event venues, airports, restaurants, and other scheduled locations to support an organized corporate itinerary."
},
{
name: "Tempo Traveller for Wedding Pimpri Chinchwad",
description: "Tempo Traveller for wedding travel in Pimpri Chinchwad is useful for transporting relatives, guests, friends, and family members between homes, hotels, wedding venues, and related functions. Shared transportation can simplify guest movement and help maintain coordinated schedules during ceremonies, receptions, pre-wedding events, and venue transfers."
},
{
name: "Tempo Traveller for School Trip Pimpri Chinchwad",
description: "School groups can use Tempo Traveller transportation from Pimpri Chinchwad for educational tours, nature excursions, historical visits, recreational programs, and organized student outings. Travel planning can be arranged around the school itinerary, pickup points, destination, sightseeing requirements, and expected return schedule."
},
{
name: "Tempo Traveller for Airport Pickup Pimpri Chinchwad",
description: "Tempo Traveller for airport pickup in Pimpri Chinchwad is suitable when families, tour groups, corporate teams, or several passengers need coordinated airport transportation with luggage. The spacious vehicle can simplify group movement between the airport, homes, hotels, offices, and onward destinations according to the planned travel schedule."
},
{
name: "Affordable Tempo Traveller Pimpri Chinchwad",
description: "Affordable Tempo Traveller services in Pimpri Chinchwad provide groups with a practical way to manage shared transportation without depending on multiple individual cars. The option can suit family outings, tourist tours, school programs, picnics, weddings, corporate travel, airport transfers, and selected outstation journeys where convenience and travel planning are important."
},
{
name: "Tempo Traveller Rental Service Pimpri Chinchwad",
description: "Tempo Traveller rental service in Pimpri Chinchwad supports a wide range of travel requirements from short local journeys to full-day excursions and multi-day tours. Travelers can plan transportation according to group size, pickup points, destination, route, travel date, sightseeing requirements, and expected duration for a more organized journey."
},
{
name: "Tempo Traveller for Picnic Pimpri Chinchwad",
description: "Tempo Traveller for picnic trips from Pimpri Chinchwad is suitable for families, friends, colleagues, and organized groups carrying food, bags, outdoor equipment, and other outing essentials. The shared vehicle works well for resorts, nature locations, amusement destinations, lakeside areas, and recreational day trips where everyone wants to travel together."
},
{
name: "Tempo Traveller for Local Sightseeing Pimpri Chinchwad",
description: "Tempo Traveller for local sightseeing in Pimpri Chinchwad provides convenient group transportation for itineraries involving several planned stops and attractions. Families, visitors, school groups, and corporate teams can use one vehicle to move between sightseeing points while keeping the group together and reducing the need for multiple separate cars."
},
{
name: "Tempo Traveller for One Day Trip Pimpri Chinchwad",
description: "A Tempo Traveller for a one-day trip from Pimpri Chinchwad is useful for groups planning a complete same-day journey to a nearby destination. The arrangement can support hill-station visits, religious tours, nature outings, picnics, and sightseeing programs where passengers want convenient transportation for the outward and return portions of the trip."
},
{
name: "Tempo Traveller for Corporate Travel Pimpri Chinchwad",
description: "Tempo Traveller for corporate travel in Pimpri Chinchwad can support employee movement, business meetings, client visits, training programs, conferences, office outings, and intercity professional journeys. Keeping team members together in one vehicle can simplify movement between offices, hotels, airports, event venues, and other business locations."
},
{
name: "Tempo Traveller for Marriage Pimpri Chinchwad",
description: "Tempo Traveller for marriage travel in Pimpri Chinchwad provides a practical group transportation option for relatives, guests, friends, and family members attending wedding celebrations. The vehicle can support movements between homes, hotels, ceremony venues, reception locations, and other scheduled functions while keeping passengers together."
},
{
name: "Tempo Traveller for Tourist Trip Pimpri Chinchwad",
description: "Tourists can hire a Tempo Traveller from Pimpri Chinchwad for sightseeing tours covering hill stations, beaches, heritage destinations, religious places, and nature attractions. Shared transportation allows the group to remain together while carrying luggage and following an itinerary that may include multiple destinations and sightseeing stops."
},
{
name: "Tempo Traveller for Outstation Tour Pimpri Chinchwad",
description: "Tempo Traveller for outstation tours from Pimpri Chinchwad is suitable for groups planning extended road journeys across Maharashtra and nearby regions. The spacious shared vehicle works well for weekend vacations, pilgrimage tours, family holidays, corporate outings, educational excursions, and multi-day sightseeing programs."
},
{
name: "Traveller Hire Pimpri Chinchwad",
description: "Traveller hire in Pimpri Chinchwad offers a flexible group transportation option for local travel, airport transfers, family outings, events, sightseeing, and long-distance journeys. Ruturaj Enterprises can support different itinerary requirements so passengers can plan shared transportation around their destination, travel schedule, group size, and trip duration."
}
],
tableData: [
["Tempo Traveller Rental Pimpri Chinchwad", "Comfortable traveller rental for family journeys, group tours, corporate programs, events, sightseeing, and outstation travel."],
["Tempo Traveller Hire Pimpri Chinchwad", "Convenient Tempo Traveller hire for families, friends, corporate teams, weddings, school trips, and tourist journeys."],
["Tempo Traveller Booking Pimpri Chinchwad", "Advance booking arrangements based on travel dates, pickup locations, destinations, group requirements, and journey duration."],
["AC Tempo Traveller Pimpri Chinchwad", "Air-conditioned Tempo Traveller option offering a comfortable cabin for local and extended group journeys."],
["Luxury Tempo Traveller Pimpri Chinchwad", "Premium traveller option for corporate movement, weddings, family holidays, executive groups, and special occasions."],
["Tempo Traveller for Outstation Pimpri Chinchwad", "Shared transportation for long-distance journeys across Maharashtra and nearby states with practical luggage space."],
["Tempo Traveller for Family Trip Pimpri Chinchwad", "Spacious family travel option for vacations, hill stations, beaches, religious journeys, and weekend getaways."],
["Tempo Traveller for Group Travel Pimpri Chinchwad", "Convenient group vehicle that keeps friends, relatives, and organized travel parties together."],
["Tempo Traveller for Corporate Events Pimpri Chinchwad", "Organized transportation for conferences, meetings, seminars, exhibitions, employee outings, and company events."],
["Tempo Traveller for Wedding Pimpri Chinchwad", "Group transportation for wedding guests, relatives, family members, hotel transfers, and ceremony venues."],
["Tempo Traveller for School Trip Pimpri Chinchwad", "Travel arrangement for educational tours, recreational outings, nature excursions, and organized school programs."],
["Tempo Traveller for Airport Pickup Pimpri Chinchwad", "Spacious airport transportation for families, corporate teams, tour groups, and passengers carrying luggage."],
["Affordable Tempo Traveller Pimpri Chinchwad", "Practical group transportation option for families, events, picnics, sightseeing, corporate travel, and tours."],
["Tempo Traveller Rental Service Pimpri Chinchwad", "Flexible rental service for local journeys, full-day trips, airport transfers, sightseeing, and multi-day tours."],
["Tempo Traveller for Picnic Pimpri Chinchwad", "Comfortable shared transportation for picnics with room for passengers, bags, food, and outdoor essentials."],
["Tempo Traveller for Local Sightseeing Pimpri Chinchwad", "Convenient multi-stop vehicle arrangement for sightseeing programs involving families, visitors, schools, and teams."],
["Tempo Traveller for One Day Trip Pimpri Chinchwad", "Shared transportation for same-day hill station, religious, nature, picnic, and sightseeing trips."],
["Tempo Traveller for Corporate Travel Pimpri Chinchwad", "Professional group transportation for employees, meetings, client visits, training programs, and business travel."],
["Tempo Traveller for Marriage Pimpri Chinchwad", "Coordinated transportation for relatives, guests, family members, wedding venues, receptions, and related functions."],
["Tempo Traveller for Tourist Trip Pimpri Chinchwad", "Comfortable group travel for beaches, hills, heritage attractions, religious destinations, and nature tours."],
["Tempo Traveller for Outstation Tour Pimpri Chinchwad", "Spacious transportation for weekend vacations, pilgrimage tours, family holidays, corporate outings, and multi-day road trips."],
["Traveller Hire Pimpri Chinchwad", "Flexible traveller hire for local travel, airport transfers, sightseeing, family outings, events, and long-distance journeys."]
],
whychoose: [
{
WhyChooseheading: "Comfortable Group Travel",
WhyChoosedescription: "A Tempo Traveller provides a practical way for medium-sized groups to remain together throughout their journey instead of arranging several separate cars. The spacious passenger layout and useful luggage capacity make it suitable for families, friends, corporate teams, school groups, and organized travel parties."
},
{
WhyChooseheading: "Ideal for Long-Distance Routes",
WhyChoosedescription: "Extended road journeys require a vehicle that can accommodate passengers and luggage comfortably for several hours. Tempo Traveller arrangements are suitable for destinations across Maharashtra and nearby states, supporting family holidays, pilgrimage trips, weekend getaways, corporate tours, and multi-day sightseeing programs."
},
{
WhyChooseheading: "Options for Different Journeys",
WhyChoosedescription: "Travel requirements can vary from a short sightseeing plan to a long multi-day holiday, so the vehicle can be selected according to the nature of the trip. AC, luxury, local, airport, wedding, school, corporate, family, and outstation requirements can all be planned around the group's itinerary."
},
{
WhyChooseheading: "Useful for Events and Functions",
WhyChoosedescription: "Weddings, corporate events, school programs, and social functions often involve multiple passengers traveling according to a common schedule. A Tempo Traveller helps coordinate movement between homes, hotels, offices, airports, venues, and other planned locations without requiring every passenger to arrange separate transportation."
},
{
WhyChooseheading: "Convenient for Family Holidays",
WhyChoosedescription: "Family trips often involve extra luggage, children, senior relatives, and multiple sightseeing stops, making shared transportation particularly useful. A Tempo Traveller allows family members to stay together while traveling toward hill stations, beaches, religious destinations, nature locations, and other holiday spots."
},
{
WhyChooseheading: "Flexible Itinerary Coordination",
WhyChoosedescription: "Group tours may include hotel transfers, meal breaks, sightseeing points, event venues, and multiple destinations within the same itinerary. Pickup locations, travel dates, route requirements, planned stops, and trip duration can be considered while arranging the vehicle to support a more organized journey."
},
{
WhyChooseheading: "Suitable for Corporate and School Groups",
WhyChoosedescription: "Companies and educational institutions often need transportation that can move several participants together according to a planned schedule. A Tempo Traveller can support employee outings, conferences, training programs, school excursions, educational visits, recreational trips, and other organized group movements."
},
{
WhyChooseheading: "Travel Support from Pimpri Chinchwad",
WhyChoosedescription: "Ruturaj Enterprises supports Tempo Traveller requirements beginning from Pimpri Chinchwad for local travel, airport transfers, sightseeing, events, family journeys, and destinations across Maharashtra and nearby regions. Travel arrangements can be planned around the group's route, schedule, passenger requirements, and intended trip duration for convenient transportation."
}
]
};
















const faqData = [
{
question: "How can I rent a Tempo Traveller in Pimpri Chinchwad?",
answer: "A Tempo Traveller can be arranged in Pimpri Chinchwad by providing the pickup location, destination, travel date, number of passengers, trip duration, and preferred departure time. Ruturaj Enterprises can organize group transportation for local sightseeing, family tours, corporate programs, weddings, pilgrimages, weekend trips, and longer outstation journeys."
},
{
question: "What types of trips can be planned with a Tempo Traveller in Pimpri Chinchwad?",
answer: "Tempo Traveller rental is useful for group journeys where passengers prefer to travel together in one vehicle. Common uses include family vacations, corporate outings, wedding transportation, school and college excursions, religious tours, sightseeing programs, picnics, airport transfers, and multi-day trips to destinations around Maharashtra and other states."
},
{
question: "Can I hire a Tempo Traveller from Pimpri Chinchwad for an outstation trip?",
answer: "Outstation Tempo Traveller rentals can be arranged from Pimpri Chinchwad for a variety of routes and destinations. Groups can plan journeys to places such as Mahabaleshwar, Goa, Shirdi, Nashik, Mumbai, Konkan, Kolhapur, Gujarat, Rajasthan, and other destinations based on the required itinerary, travel duration, and passenger count."
},
{
question: "Is a Tempo Traveller suitable for family tours from Pimpri Chinchwad?",
answer: "Families traveling together can consider a Tempo Traveller when they want shared transportation throughout their journey. The itinerary can include multiple sightseeing locations, meal breaks, hotel transfers, religious places, scenic stops, and return travel while allowing relatives to remain together instead of arranging several separate cars."
},
{
question: "Can I rent a Tempo Traveller for a corporate trip in Pimpri Chinchwad?",
answer: "Corporate groups can use Tempo Traveller rental for employee outings, business visits, conferences, training programs, industrial visits, team activities, exhibitions, and company events. Pickup points can be coordinated around offices and residential areas in Pimpri Chinchwad, with the journey arranged according to the event schedule and destination."
},
{
question: "Can a Tempo Traveller be hired for weddings in Pimpri Chinchwad?",
answer: "Wedding transportation can be organized with a Tempo Traveller for guests and relatives traveling between homes, hotels, banquet halls, wedding venues, railway stations, and airports. Multiple transfers can be included in the schedule so that the group's transportation remains aligned with ceremonies, reception timings, and venue changes."
},
{
question: "Can I hire a Tempo Traveller for a pilgrimage from Pimpri Chinchwad?",
answer: "Pilgrimage groups can arrange a Tempo Traveller for temple tours and religious journeys involving multiple destinations. The travel plan may include darshan locations, overnight stays, meal breaks, rest stops, and return travel. A shared vehicle can make it easier for the group to follow one coordinated itinerary."
},
{
question: "Which passenger groups can use a Tempo Traveller rental?",
answer: "Tempo Traveller rentals can accommodate different types of groups depending on the vehicle configuration and available seating capacity. Families, friends, corporate teams, wedding guests, students, tourists, and pilgrimage groups can select a suitable vehicle according to passenger numbers, luggage requirements, travel distance, and trip duration."
},
{
question: "What information is needed when booking a Tempo Traveller in Pimpri Chinchwad?",
answer: "For a suitable rental arrangement, share the pickup point, destination, travel date, passenger count, luggage details, journey duration, planned stops, and preferred departure and return timings. Providing the complete route helps Ruturaj Enterprises understand the group's transportation needs and coordinate the trip accordingly."
},
{
question: "Why choose Ruturaj Enterprises for Tempo Traveller On Rent in Pimpri Chinchwad?",
answer: "Ruturaj Enterprises arranges Tempo Traveller transportation for family vacations, corporate travel, weddings, pilgrimages, sightseeing tours, picnics, airport transfers, and outstation journeys from Pimpri Chinchwad. The travel plan can be organized around group size, pickup locations, destinations, trip duration, planned stops, luggage, and the overall itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Prakash More",
feedback:
"Our group rented a Tempo Traveller from Ruturaj Enterprises for a multi-day journey from Pimpri Chinchwad. Traveling together made the trip easier to coordinate, particularly because we had several sightseeing stops and hotel transfers included in the itinerary. It was a practical arrangement for our larger group.",
rating: 5
},
{
id: 2,
name: "Miss. Neha Pawar",
feedback:
"I arranged a Tempo Traveller through Ruturaj Enterprises for a family pilgrimage from Pimpri Chinchwad. Having everyone in one vehicle helped us manage the temple visits, meal breaks, and return schedule more conveniently. The shared transportation also made the long journey more comfortable for our group.",
rating: 5
}
];



































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Pimpri Chinchwad",
  "image": "https://ruturajenterprises.com/assets/images/tempo-traveller-on-rent-in-pimpri-chinchwad.webp",
  "description":
    "Tempo Traveller On Rent in Pimpri Chinchwad for family trips, group tours, corporate travel, weddings, school and college excursions, picnics, sightseeing, airport transfers and outstation journeys. Ruturaj Enterprises provides Tempo Traveller rental, hire and booking services with AC and luxury options for comfortable group transportation. Spacious vehicles, experienced drivers and flexible rental plans make these Tempo Travellers suitable for one-day trips, weekend getaways, multi-day tours and long-distance travel from Pimpri Chinchwad to destinations across Maharashtra and other states.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/tempo-traveller-on-rent-in-pimpri-chinchwad"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Tempo Traveller On Rent in Pimpri Chinchwad | Tempo Traveller Hire Pimpri Chinchwad | +91 9763381382
  </title>

  <meta
    name="description"
    content="Tempo Traveller On Rent in Pimpri Chinchwad for family trips, group travel, corporate events, weddings, school trips, picnics, sightseeing and outstation journeys. Hire AC and luxury Tempo Travellers from Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="Tempo Traveller Rental Pimpri Chinchwad, Tempo Traveller Hire Pimpri Chinchwad, Tempo Traveller Booking Pimpri Chinchwad, AC Tempo Traveller Pimpri Chinchwad, Luxury Tempo Traveller Pimpri Chinchwad, Tempo Traveller for Outstation Pimpri Chinchwad, Tempo Traveller for Family Trip Pimpri Chinchwad, Tempo Traveller for Group Travel Pimpri Chinchwad, Tempo Traveller for Corporate Events Pimpri Chinchwad, Tempo Traveller for Wedding Pimpri Chinchwad, Tempo Traveller for School Trip Pimpri Chinchwad, Tempo Traveller for Picnic Pimpri Chinchwad, Tempo Traveller for Airport Pickup Pimpri Chinchwad, Affordable Tempo Traveller Rental Pimpri Chinchwad, Tempo Traveller On Rent Pimpri Chinchwad, Tempo Traveller On Rent in Pimpri Chinchwad, Tempo Traveller Rental Service Pimpri Chinchwad, Tempo Traveller Hire Service Pimpri Chinchwad, Tempo Traveller Booking Service Pimpri Chinchwad, AC Tempo Traveller Rental Pimpri Chinchwad, AC Tempo Traveller On Rent Pimpri Chinchwad, AC Tempo Traveller Hire Pimpri Chinchwad, AC Tempo Traveller Booking Pimpri Chinchwad, Luxury Tempo Traveller Rental Pimpri Chinchwad, Luxury Tempo Traveller On Rent Pimpri Chinchwad, Luxury Tempo Traveller Hire Pimpri Chinchwad, Luxury Tempo Traveller Booking Pimpri Chinchwad, Tourist Tempo Traveller Pimpri Chinchwad, Tourist Tempo Traveller Rental Pimpri Chinchwad, Tourist Tempo Traveller Hire Pimpri Chinchwad, Tourist Tempo Traveller Booking Pimpri Chinchwad, Outstation Tempo Traveller Pimpri Chinchwad, Outstation Tempo Traveller Rental Pimpri Chinchwad, Outstation Tempo Traveller Hire Pimpri Chinchwad, Outstation Tempo Traveller Booking Pimpri Chinchwad, One Way Tempo Traveller Pimpri Chinchwad, One Way Tempo Traveller Rental Pimpri Chinchwad, One Way Tempo Traveller Hire Pimpri Chinchwad, Round Trip Tempo Traveller Pimpri Chinchwad, Round Trip Tempo Traveller Rental Pimpri Chinchwad, Round Trip Tempo Traveller Hire Pimpri Chinchwad, Local Tempo Traveller Pimpri Chinchwad, Local Tempo Traveller Rental Pimpri Chinchwad, Local Tempo Traveller Hire Pimpri Chinchwad, Local Tempo Traveller Booking Pimpri Chinchwad, Family Tempo Traveller Pimpri Chinchwad, Family Tour Tempo Traveller Pimpri Chinchwad, Family Travel Tempo Traveller Pimpri Chinchwad, Group Tempo Traveller Pimpri Chinchwad, Group Tour Tempo Traveller Pimpri Chinchwad, Group Travel Tempo Traveller Pimpri Chinchwad, Corporate Tempo Traveller Pimpri Chinchwad, Corporate Tempo Traveller Rental Pimpri Chinchwad, Corporate Tempo Traveller Hire Pimpri Chinchwad, Corporate Tempo Traveller Booking Pimpri Chinchwad, Corporate Staff Transportation Tempo Traveller Pimpri Chinchwad, Corporate Event Tempo Traveller Pimpri Chinchwad, Event Tempo Traveller Rental Pimpri Chinchwad, Event Tempo Traveller Hire Pimpri Chinchwad, Event Tempo Traveller Booking Pimpri Chinchwad, Wedding Tempo Traveller Pimpri Chinchwad, Wedding Tempo Traveller Rental Pimpri Chinchwad, Wedding Tempo Traveller Hire Pimpri Chinchwad, Wedding Tempo Traveller Booking Pimpri Chinchwad, Wedding Guest Tempo Traveller Pimpri Chinchwad, Wedding Guest Transportation Tempo Traveller Pimpri Chinchwad, Marriage Tempo Traveller Pimpri Chinchwad, Marriage Tempo Traveller Rental Pimpri Chinchwad, Marriage Tempo Traveller Hire Pimpri Chinchwad, School Tempo Traveller Pimpri Chinchwad, School Trip Tempo Traveller Pimpri Chinchwad, School Tour Tempo Traveller Pimpri Chinchwad, College Trip Tempo Traveller Pimpri Chinchwad, College Tour Tempo Traveller Pimpri Chinchwad, Picnic Tempo Traveller Pimpri Chinchwad, Picnic Tempo Traveller Rental Pimpri Chinchwad, Picnic Tempo Traveller Hire Pimpri Chinchwad, Family Picnic Tempo Traveller Pimpri Chinchwad, Group Picnic Tempo Traveller Pimpri Chinchwad, Airport Tempo Traveller Pimpri Chinchwad, Airport Transfer Tempo Traveller Pimpri Chinchwad, Airport Pickup Tempo Traveller Pimpri Chinchwad, Airport Drop Tempo Traveller Pimpri Chinchwad, Sightseeing Tempo Traveller Pimpri Chinchwad, Sightseeing Tempo Traveller Rental Pimpri Chinchwad, Sightseeing Tempo Traveller Hire Pimpri Chinchwad, Pimpri Chinchwad City Tour Tempo Traveller, Tempo Traveller for Maharashtra Tour Pimpri Chinchwad, Tempo Traveller for Weekend Trip Pimpri Chinchwad, Tempo Traveller for Holiday Trip Pimpri Chinchwad, Tempo Traveller for Temple Tour Pimpri Chinchwad, Pilgrimage Tempo Traveller Pimpri Chinchwad, Tempo Traveller for Tourist Pimpri Chinchwad, Tempo Traveller with Driver Pimpri Chinchwad, Tempo Traveller Rental with Driver Pimpri Chinchwad, Tempo Traveller Hire with Driver Pimpri Chinchwad, Tempo Traveller Booking with Driver Pimpri Chinchwad, Comfortable Tempo Traveller Pimpri Chinchwad, Premium Tempo Traveller Pimpri Chinchwad, Professional Tempo Traveller Rental Pimpri Chinchwad, Reliable Tempo Traveller Hire Pimpri Chinchwad, Tempo Traveller Transportation Pimpri Chinchwad, Group Transportation Tempo Traveller Pimpri Chinchwad, Tempo Traveller Service Pimpri Chinchwad, Tempo Traveller Rental Near Me Pimpri Chinchwad, Tempo Traveller Hire Near Me Pimpri Chinchwad, Ruturaj Enterprises Tempo Traveller Rental Pimpri Chinchwad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempootravelleronrent;